import { render, staticRenderFns } from "./qualificationMaterials.vue?vue&type=template&id=19672b88&scoped=true&"
import script from "./qualificationMaterials.vue?vue&type=script&lang=js&"
export * from "./qualificationMaterials.vue?vue&type=script&lang=js&"
import style0 from "./qualificationMaterials.vue?vue&type=style&index=0&id=19672b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19672b88",
  null
  
)

export default component.exports